/* -------------------------------------------------------------------------- */
/*                                External Data                               */
/* -------------------------------------------------------------------------- */
import formLeadRecipients from "@data/pre-qualify-form-lead-recipients.json"

/* -------------------------------------------------------------------------- */
/*                                  Variables                                 */
/* -------------------------------------------------------------------------- */
export let citiesByState = {}

for (const state in formLeadRecipients) {
  const stateCities = formLeadRecipients[state].cities
  if (stateCities) {
    citiesByState[state] = Object.keys(stateCities).sort((cityA,cityB) => {
      if (cityA > cityB) return 1
      if (cityA === cityB) return 0
      return -1
    })
  }
}

/* -------------------------------------------------------------------------- */
/*                                  Functions                                 */
/* -------------------------------------------------------------------------- */
export const getBreakpoints = ({windowWidth, isMounted}) => {
  const minTablet = windowWidth && windowWidth > 1079

  return {
    mobile: isMounted && windowWidth > 0 && windowWidth < 1080,
    minMobile: isMounted && windowWidth > 0,
    minTablet : isMounted && windowWidth > 0 && windowWidth > 1079,
    tablet : isMounted && windowWidth > 0 && minTablet && windowWidth < 1452,
    desktop : isMounted && windowWidth > 0 && windowWidth > 1451
  }
}
